export class Product {
    title:string;
    id:string;

    constructor(product:any) {
        this.title = product.title;
        this.id = product.id;
    }
}